// extracted by mini-css-extract-plugin
export default {"container":"Rp-z","brandName":"Sp-z","productName":"Tp-z","productNamePdpEnhancements":"Up-z","breakLongProductName":"Vp-z"};